import selectCustomer from '../components/selectCustomer/index.vue'
import masterOrderSign from '../components/masterOrderSign/index.vue'
import masterOrderLease from '../components/masterOrderLease/index.vue'
import createdSuccess from '../components/createdSuccess/index.vue'

export default function () {
  const stepsList = [
    {
      id: 0,
      title: '选择客户',
      component: selectCustomer,
    },
    {
      id: 1,
      title: '主订单签约',
      component: masterOrderSign,
    },
    {
      id: 2,
      title: '主订单租赁设置',
      component: masterOrderLease,
    },
    {
      id: 3,
      title: '完成',
      component: createdSuccess,
    },
  ]
  const previewList = [
    {
      el: 'text',
      itemConfig: {
        label: '所属公司',
        prop: 'companyName',
      },
      stepActive: [1, 2],
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户类型',
        prop: 'customerType',
        value: '企业客户',
      },
      stepActive: [1, 2],
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户名称',
        prop: 'customerName',
        width: 110,
      },
      stepActive: [1, 2],
    },
    {
      el: 'text',
      itemConfig: {
        label: '合同起止日期',
        prop: 'contractDate',
      },
      stepActive: [2],
    },
    {
      el: 'text',
      itemConfig: {
        label: '租赁车辆数',
        prop: 'carTotalNum',
      },
      stepActive: [2],
    },
  ]
  return {
    stepsList,
    previewList,
  }
}
